import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import WarningIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/WarningIcon'
import ErrorIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/ErrorIcon'

const EnergyPerCow: React.FC = () => {
  const { control, clearErrors, setError } = useFormContext()

  const watchEnergyUse = useWatch({ control, name: 'energyUse' })
  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })

  const energyConsumptionPerCow = useMemo(() => {

    if (watchEnergyUse && watchCowsNumber) {
      const energyConsumption = Math.floor(watchEnergyUse / watchCowsNumber)
      if (energyConsumption < 150 || energyConsumption > 1000) {
        setError('energyCowConsumption', { message: 'Der Stromverbrauch pro Kuh und Jahr muss mind. 150 kWh und darf max. 1.000 kWh.' })
      } else {
        clearErrors('energyCowConsumption')
      }

      return energyConsumption
    }

    return 0
  }, [watchCowsNumber, watchEnergyUse])

  return <Form.Field>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
        <div>{'kWh pro Kuh u. Jahr'}</div>
        {(energyConsumptionPerCow < 150 || energyConsumptionPerCow > 500) && <WarningIcon
          control={control}
          name='energyCowConsumption'
          content={'Der Stromverbrauch pro Kuh und Jahr liegt außerhalb der normalen Bereiche von mind. 150 kWh und max. 500 kWh.'}
        />}
        <ErrorIcon
          control={control}
          name={'energyCowConsumption'}
        />
      </label>
      <div>{`${energyConsumptionPerCow} kWh pro Kuh u. Jahr`}</div>
    </MilkProductionField>
  </Form.Field>
}
export default EnergyPerCow